import React from "react";
import PropTypes from "prop-types";

import Loading from "../../common/Loading";

import SalesPerformanceItem from "./SalesPerformanceItem";

const SalesPerformancePageList = ({ data, loading }) => {
  if (loading)
    return (
      <div className="loading">
        <Loading />
      </div>
    );
  return data && data.length ? (
    data.map(
      ({ _id: id, salesperson, billableHours, projects, totalBilled }) => (
        <SalesPerformanceItem
          key={id}
          salesperson={salesperson}
          billableHours={billableHours}
          projects={projects}
          totalBilled={totalBilled}
        />
      )
    )
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};

SalesPerformancePageList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool
};

export default SalesPerformancePageList;
